import { render, staticRenderFns } from "./DocumentLibrary.vue?vue&type=template&id=3fff6238&"
import script from "./DocumentLibrary.vue?vue&type=script&lang=ts&"
export * from "./DocumentLibrary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports